import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { DeviceDetectorService } from 'ngx-device-detector';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import {
  selectPropertiesCount,
  selectPropertiesLoading,
} from '@state/properties/properties.selectors';
import {
  selectOrganizationUrlSlug,
  selectOrganizationPropertiesCount,
  selectOrganizationPropertiesLoading,
} from '@state/organization/organization.selectors';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-home-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderComponent implements OnInit {
  @Input() disabled = false;
  @Input({ required: true }) isLoggedIn = false;

  protected checked = false;
  protected locations?: string = undefined;
  protected isMobile = false;

  protected loading$ = this.store.select(selectPropertiesLoading);
  protected count = 0;

  protected orgPropertiesLoading$ = this.store.select(
    selectOrganizationPropertiesLoading
  );
  protected orgPropertiesCount$ = this.store.select(
    selectOrganizationPropertiesCount
  );

  protected isExternalOrg = false;

  constructor(
    private store: Store<AppState>,
    private deviceService: DeviceDetectorService
  ) {}

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();

    this.locations = undefined;

    this.store
      .select(selectPropertiesCount)
      .pipe(untilDestroyed(this))
      .subscribe((count) => {
        this.count = count || 0;
      });

    this.store
      .select(selectOrganizationUrlSlug)
      .pipe(untilDestroyed(this))
      .subscribe((orgUrlSlug) => {
        this.isExternalOrg = !!orgUrlSlug;
      });
  }
}
